export interface OidcSignupCompleteRegistrationConfig {
    OIDC_SIGNUP_COMPLETE_REQUIRED?: boolean;
    OIDC_SIGNUP_COMPLETE_FIELD_ORDER?: Record<string, unknown>;
}

export interface LoginPageUtil {
    hasOidcSignupCompleteConfig: (registration: OidcSignupCompleteRegistrationConfig | undefined) => boolean;
    shouldNavigateToOidcSignupComplete: (
        registration: OidcSignupCompleteRegistrationConfig | undefined,
        authCustomerData: Record<string, unknown>,
        customerProfileData: Record<string, unknown> | null | undefined
    ) => boolean;
    isOidcRequiredFieldPresent: (fieldKey: string, profileData: Record<string, unknown>) => boolean;
}

function hasOidcSignupCompleteConfig(registration: OidcSignupCompleteRegistrationConfig | undefined): boolean {
    if (!registration?.OIDC_SIGNUP_COMPLETE_REQUIRED) {
        return false;
    }

    const requiredFieldKeys = Object.keys(registration?.OIDC_SIGNUP_COMPLETE_FIELD_ORDER ?? {});
    return requiredFieldKeys.length > 0;
}

function isOidcRequiredFieldPresent(fieldKey: string, profileData: Record<string, unknown>): boolean {
    if (fieldKey === 'PHONE_NUMBER') {
        const phoneNumberValue =
            profileData.phoneNumber ?? (profileData.phone as { number?: string })?.number ?? profileData.phone_number;
        return !!phoneNumberValue;
    }

    if (fieldKey === 'PERSONAL_CODE') {
        const personalCodeValue =
            profileData.personalCode ?? profileData.personal_code ?? profileData.nationalIdentityNumber;
        return !!personalCodeValue;
    }

    return true;
}

function shouldNavigateToOidcSignupComplete(
    registration: OidcSignupCompleteRegistrationConfig | undefined,
    authCustomerData: Record<string, unknown>,
    customerProfileData: Record<string, unknown> | null | undefined
): boolean {
    if (!hasOidcSignupCompleteConfig(registration)) {
        return false;
    }

    const requiredFieldKeys = Object.keys(registration?.OIDC_SIGNUP_COMPLETE_FIELD_ORDER ?? {});
    const profileData = { ...authCustomerData, ...(customerProfileData ?? {}) };

    return requiredFieldKeys.some((fieldKey) => !isOidcRequiredFieldPresent(fieldKey, profileData));
}

export const LoginPageUtils: LoginPageUtil = {
    hasOidcSignupCompleteConfig,
    shouldNavigateToOidcSignupComplete,
    isOidcRequiredFieldPresent
};
